import script from "./MyList.vue?vue&type=script&setup=true&lang=js"
export * from "./MyList.vue?vue&type=script&setup=true&lang=js"

import "./MyList.vue?vue&type=style&index=0&id=79d4ccee&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79d4ccee"]])

export default __exports__